import Festivos from './festivos.vue';
import FestivosBoletin from './festivos-boletin.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

// Dos pantallas: el catálogo de Ajustes · Festivos (#53) en `/festivos/` y «Leer boletines»
// (#55) en `/festivos/boletin/`. Cuelgan de rutas distintas a propósito; compartirla dejaba una
// de las dos inalcanzable según cuál de los dos PRs se mezclara después.
// El acceso de verdad lo pone el backend (403 al que no sea ADMIN o DIRECTOR) y la entrada del
// menú; checkPermission es lo que evita entrar por URL a una pantalla que no se puede usar.
var routes = [
    {
        path: '/festivos/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('festivos', ['ADMIN', 'DIRECTOR'], Festivos),
        keepAlive: true
    },
    {
        path: '/festivos/boletin/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('festivos', ['ADMIN', 'DIRECTOR'], FestivosBoletin),
        keepAlive: true
    }
];
export default routes;
